import { FC, SyntheticEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import EventsTable from './EventsTable'
import { deleteEventWithScope } from './recurrence'
import EventEditModal from './EventEditModal'

const EventsList: FC = () => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState('')
  const [refreshFunction, setRefreshFunction] = useState<any>(() => {})
  const navigate = useNavigate()

  return (
    <>
      <div className='d-flex gap-2 mb-4'>
        <button
          className='btn btn-sm btn-light'
          onClick={() => {
            navigate('/events/list')
          }}
        >
          <span className='fa fa-list me-2'></span>
          List View
        </button>
        <button
          className='btn btn-sm btn-light'
          onClick={() => {
            navigate('/events/calendar')
          }}
        >
          <span className='fa fa-calendar me-2'></span>
          Calendar View
        </button>
      </div>
      <EventsTable
        onEdit={(id: any, refresh: Function) => {
          setRefreshFunction(() => refresh)
          setItemIdForUpdate(id)
        }}
        onDelete={(id: any, refresh: Function) => {
          deleteEventWithScope(id).then((deleted) => {
            if (deleted) {
              refresh()
            }
          })
        }}
        onAdd={(_event: SyntheticEvent, refresh: Function) => {
          setItemIdForUpdate('add')
          setRefreshFunction(() => refresh)
        }}
      />
      {itemIdForUpdate !== '' ? (
        <EventEditModal
          show={itemIdForUpdate !== ''}
          itemIdForUpdate={itemIdForUpdate}
          onHide={() => {
            setItemIdForUpdate('')
          }}
          refreshFunction={(itemId: any) => {
            if (itemId !== undefined) {
              setItemIdForUpdate(itemId)
            }
            refreshFunction()
          }}
        />
      ) : (
        <></>
      )}
    </>
  )
}
export default EventsList
